import React from 'react';
import { SHARING_REQUEST_STATUS, pendingGroupsSubtitle } from './sharingRequestModel';
import styles from './VisibilitySharing.module.css';

const STATUS_CLASS = {
    [SHARING_REQUEST_STATUS.PENDING]: styles.statusPending,
    [SHARING_REQUEST_STATUS.ACCEPTED]: styles.statusAccepted,
    [SHARING_REQUEST_STATUS.REJECTED]: styles.statusRejected,
    [SHARING_REQUEST_STATUS.MIXED]: styles.statusMixed
};

const StatusChip = ({ status, pendingGroupCount }) => {
    const subtitle = pendingGroupsSubtitle(pendingGroupCount);
    return (
        <span className={styles.status}>
            <span className={`${styles.statusLabel} ${STATUS_CLASS[status] || ''}`}>{status}</span>
            {subtitle ? <span className={styles.subtitle}>{subtitle}</span> : null}
        </span>
    );
};

export default StatusChip;
